import { Types } from '@antv/g2';

export type Scrollbar = Types.ScrollbarOption;
